<template>
  <div id="app-container" class="app-container-box" v-if="!is_loading">
    <div
      class="check-detail-box"
      :style="{
        'background-image': `url(${
          checkDetail.isSport ? sport_poster : art_poster
        })`,
      }"
    >
      <div class="list-item">
        <div class="item-header">
          <div class="header-left">
            <img class="left-img" :src="checkDetail.user_fmt.avatar" />
            <div class="left-name-box">
              <div class="name-top">
                <span>{{ checkDetail.user_fmt.realname }}</span>
                <img
                  class="name-label-img"
                  src="../../assets/icon_mark_sport.png"
                  v-if="checkDetail.classify_id == 1"
                />
                <img
                  class="name-label-img"
                  src="../../assets/icon_mark_art.png"
                  v-else
                />
              </div>
              <span class="name-time">{{ checkDetail.create_time_fmt }}</span>
            </div>
          </div>
          <div class="header-right" @click="startPraise(checkDetail)">
            <span class="right-text">{{ checkDetail.praise_num }}</span>
            <img class="right-img" src="../../assets/icon_fav_select.png" />
          </div>
        </div>
        <div class="item-content">
          <div class="content-line-box">
            <span class="content-label"
              >{{ checkDetail.classify_id == 1 ? "运动" : "活动" }}项目</span
            ><span class="content-content">{{ checkDetail.item_fmt }}</span>
          </div>
          <div class="content-line-box">
            <span class="content-label"
              >{{ checkDetail.classify_id == 1 ? "运动" : "活动" }}时间</span
            ><span class="content-content">{{
              checkDetail.start_time_fmt + "-" + checkDetail.end_time_fmt
            }}</span>
          </div>
          <div class="content-line-box">
            <span class="content-label"
              >{{ checkDetail.classify_id == 1 ? "运动" : "活动" }}地点</span
            ><span class="content-content">{{
              checkDetail.place_type_fmt
            }}</span>
          </div>
          <div class="content-imgs">
            <img
              v-for="imgPath in checkDetail.imgs"
              v-lazy="imgPath"
              :key="imgPath"
            />
          </div>
        </div>
      </div>
    </div>
    <van-button
      class="button_select poster_button"
      @click="showPoster = true"
      v-if="checkDetail.isMy"
      >生成海报</van-button
    >

    <van-popup
      v-model:show="showPoster"
      closeable
      overlay-class="header-overlay"
    >
      <div class="popup-box">
        <div class="poster-box" ref="postRef">
          <div class="poster-top">
            <img
              class="poster-top-bg"
              :style="{
                'background-image': `url(${checkDetail.imgs[0]})`,
              }"
            />
            <!-- <img
              class="poster-top-bg"
              :style="{
                'background-image': `url(${
                  checkDetail.isSport ? sport_poster : art_poster
                })`,
              }"
            /> -->
            <!-- <img class="poster-top-bg" :src="checkDetail.imgs[0]" /> -->
            <div class="poster-top-black"></div>
            <!-- <img class="poster-top-bg" :src="checkDetail.imgs[0]" /> -->
            <div class="poster-ps">
              <p class="poster-title">WELL DONE</p>
              <p class="poster-title">完成{{ poster_name }}打卡</p>
              <p class="poster-item">
                <span class="item-label">{{ lable_name }}项目：</span
                ><span class="item-content">{{ checkDetail.item_fmt }}</span>
              </p>
              <p class="poster-item">
                <span class="item-label">{{ lable_name }}时间：</span
                ><span class="item-content">{{ checkDetail.sport_time }}</span>
              </p>
              <p class="poster-item">
                <span class="item-label">{{ lable_name }}地点：</span
                ><span class="item-content">{{
                  checkDetail.place_type_fmt
                }}</span>
              </p>
            </div>
          </div>
          <div class="poster-bottom">
            <div class="footer-name">
              <img :src="checkDetail.user_fmt.avatar" />
              <span>{{ checkDetail.user_fmt.realname }}</span>
            </div>
            <img class="footer-logo" src="../../assets/icon_school_logo.png" />
          </div>
        </div>

        <van-button
          class="button_select upload_style_button button_margin"
          @click="startProducePoster"
          >保存到手机</van-button
        >
      </div>
    </van-popup>
  </div>
  <div class="loading-box" v-else>
    <van-loading color="#ffffff" vertical>加载中...</van-loading>
  </div>
</template>
<script setup>
import { ref, onMounted } from "vue";
import req from "@/js/req";
import { useRouter } from "vue-router";
import { showNotify } from "vant";
import html2canvas from "html2canvas";
import User from "../../js/user";
import sport_poster from "@/assets/sport_poster.jpg";
import art_poster from "@/assets/art_poster.jpg";

const showPoster = ref(false);
const postRef = ref();
const router = useRouter();
const poster_bg = ref("");
const checkDetail = ref({
  user_fmt: {},
});
const lable_name = ref("运动");
const poster_name = ref("体育");

const is_loading = ref(false);

onMounted(() => {
  const id = router.currentRoute.value.query.id;
  getCheckDetail(id);
});
const startPraise = async (item) => {
  const p = {
    record_id: item.record_id,
    ...User.getUTP(),
  };
  let data = await req.post(req.path.praise_, p);
  if (data > 0) {
    item.praise_num = data;
  }
};
const getCheckDetail = async (id) => {
  is_loading.value = true;
  let data = await req.get(req.path.get_item_detail, { record_id: id });
  data.isSport = data.classify_id == 1;
  lable_name.value = data.isSport ? "运动" : "活动";
  poster_name.value = data.isSport ? "体育" : "艺术活动";
  data.imgs = JSON.parse(data.images_fmt);
  data.sport_time = `${data.start_time_fmt}-${data.end_time_fmt}`;
  data.isMy = User.getUid() == data.user_fmt.user_id;
  checkDetail.value = data;
  // imagesToBase64(checkDetail.value.user_fmt.avatar);
  is_loading.value = false;

  User.getInstance()._nav_title_callback_(
    data.isSport ? "体育活动打卡" : "艺术活动打卡"
  );
};
// const showPreVieImages = (index) => {
//   showImagePreview({
//     images: checkDetail.value.imgs,
//     startPosition: index,
//     closeable: true,
//   });
// };
const imagesToBase64 = (src) => {
  let image = new Image();
  image.setAttribute("crossOrigin", "anonymous");
  console.log("base_64_:::", src);
  image.onload = () => {
    var canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    var context = canvas.getContext("2d");
    context.drawImage(image, 0, 0, image.width, image.height);
    poster_bg.value = canvas.toDataURL("image/jpeg", 0.8);
    console.log("base_64_:::", poster_bg.value);
  };
  image.src = src;
};

const startProducePoster = () => {
  const dom = postRef.value;
  html2canvas(dom, {
    useCORS: true,
    dpi: window.devicePixelRatio * 2,
    scale: 2,
    scrollX: 0,
    scrollY: 0,
    x: 1,
    width: dom.clientWidth - 1,
    logging: false,
  }).then((canvas) => {
    let dataURL = canvas.toDataURL("image/png");
    let a = document.createElement("a");
    document.body.appendChild(a);
    a.href = dataURL;
    a.download = "分享图";
    a.click();
    showNotify({ type: "success", message: "保存成功" });
    showPoster.value = false;
  });
};
</script>
<style lang="scss" scoped>
.app-container-box {
  .check-detail-box {
    border-radius: 8px;
    overflow: hidden;
    background-image: url(../../assets/art_poster.jpg);
    background-repeat: no-repeat;
    background-size: 100% auto;

    .images-box {
      width: 100%;

      img {
        width: 220px;
        height: 165px;
        margin-right: 5px;
        object-fit: cover;
        background-image: url(../../assets/placeholder.jpg);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border-radius: 8px;

        &:last-of-type {
          margin-right: 0;
        }
      }
    }
  }

  .poster_button {
    background: var(--c-blue-linear-gradient-1) !important;
    width: 100%;
    height: 96px;
    font-weight: bold;
    font-size: 38px;
    // margin: 16px;
    position: fixed;
    bottom: 40px;
    left: 0;
  }
}
.loading-box {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
.popup-box {
  width: 720px;

  //   width: 100%;
  .poster-box {
    background-color: white;
    margin-bottom: 300px;
    margin-top: 200px;

    .poster-top {
      padding: 36px 48px 72px 36px;
      position: relative;
      height: 420px;
      box-sizing: border-box;

      .poster-top-bg {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-size: cover;
        background-repeat: no-repeat;
        background-position-y: 50%;
        object-fit: cover;
      }

      .poster-top-black {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        // background: white;
        background: linear-gradient(
          to right,
          rgba(0, 0, 0, 0.8),
          rgba(0, 0, 0, 0)
        );
      }

      .poster-ps {
        position: absolute;
        bottom: 36px;
      }

      .poster-title {
        font-size: 28px;
        color: #1095f2;
        font-weight: bold;
        text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
      }

      .poster-item {
        display: flex;
        margin-top: 10px;

        .item-label {
          font-size: 18px;
          color: var(--c-text-color-gray-10);
          flex-shrink: 0;
          text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
        }

        .item-content {
          font-size: 18px;
          color: #f1f4f8;
          display: inline-block;
          text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.4);
        }
      }
    }

    .poster-bottom {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 24px;
      box-sizing: border-box;

      .footer-name {
        display: flex;
        align-items: center;
        font-size: 32px;
        font-weight: bold;
        color: var(--c-text-color-black-8);

        img {
          width: 80px;
          height: 80px;
          border-radius: 100%;
          margin-right: 16px;
        }
      }

      .footer-logo {
        width: 290px;
        height: 62px;
      }
    }
  }

  //   .button_margin{
  //      margin-top: 300px;
  //   }
}

.list-item {
  margin: 300px 16px 160px;
  padding: 24px;
  background-color: white;
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.2);
  // margin-top: 32px;
  border-radius: 8px;

  .item-header {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .header-left {
      display: flex;

      .left-img {
        width: 80px;
        height: 80px;
        border-radius: 100%;
        object-fit: cover;
      }

      .left-name-box {
        display: flex;
        flex-direction: column;
        margin-left: 12px;

        .name-top {
          color: var(--c-text-color-black-8);
          font-size: 32px;
          font-weight: bold;
          display: flex;
          align-items: center;

          .name-label-img {
            width: 160px;
            height: 36px;
            margin-left: 16px;
          }
        }

        .name-time {
          font-size: 22px;
          color: var(--c-text-color-gray-6);
        }
      }
    }

    .header-right {
      display: flex;
      align-items: center;
      flex-direction: row;

      .right-text {
        color: var(--c-text-color-red);
        font-size: 22px;
      }

      .right-img {
        width: 40px;
        height: 40px;
        margin-left: 12px;
      }
    }
  }

  .item-content {
    .content-line-box {
      display: flex;
      align-items: center;
      margin-top: 24px;

      .content-label {
        font-size: 28px;
        color: var(--c-text-color-gray-6);
        flex-shrink: 0;
      }

      .content-content {
        font-size: 28px;
        color: var(--c-text-color-black-8);
        padding: 0px 20px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }

    .content-imgs {
      margin-top: 24px;

      img {
        width: 100%;
        object-fit: cover;
        background-image: url(../../assets/placeholder.jpg);
        background-size: 100% 100%;
        background-repeat: no-repeat;
        border-radius: 8px;
      }

      .img_box {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .one_img {
        img {
          width: 100%;
        }
      }

      .two_img {
        img {
          width: 49.5%;
          height: 250px;
        }
      }

      .three_img {
        img {
          width: 220px;
          height: 165px;
        }
      }
    }
  }
}
::v-deep .van-loading {
  background-color: rgba(0, 0, 0, 0.6);
  padding: 50px;
  border-radius: 10px;
}
-deep .van-cell__le {
  font-size: 28px;
  color: var(--c-text-color-gray-6);
  width: 200px;
  flex: initial;
}

::v-deep .van-cell__value {
  font-size: 32px;
  color: var(--c-text-color-black-8);
  text-align: left;
  text-align: justify;
}

::v-deep .van-cell {
  padding: 32px 24px;
  line-height: initial;
}

::v-deep .van-popup--center {
  max-width: initial;
}

::v-deep .van-popup {
  background: transparent;
}

::v-deep .header-overlay {
  background-color: rgba(0, 0, 0, 0.8);
  backdrop-filter: blur(10px);
}
</style>
